<template>
  <LayoutDefault>
    <section class="cooperation">
      <h1 class="cooperation__title">Структура и органы управления образовательной организацией</h1>
      <table class="cooperation__table">
        <thead>
          <tr>
            <th class="cooperation__table-title">Категория</th>
            <th class="cooperation__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in cooperationCategories" :key="idx">
            <td class="cooperation__categories">
              <p>{{ item.name }}</p>
            </td>
            <td class="cooperation__filling">
              <Textarea
                v-model="item.description"
                autoResize rows="1"
                cols="70"
                @change="test"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <BaseBtn blue text="Сохранить" />
    </section>
  </LayoutDefault>
</template>

<script>
import { ref } from 'vue'
import LayoutDefault from '@/layout/LayoutDefault'
import BaseBtn from '@/components/ui/BaseBtn.vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'InternationalCooperationView',
  components: {
    LayoutDefault,
    Textarea,
    BaseBtn
  },
  props: {
  },
  setup () {
    const cooperationCategories = ref([
      {
        id: 1,
        name: 'О заключенных и планируемых к заключению договорах с иностранными и (или) международными организациями по вопросам образования и науки (при наличии)',
        description: 'У образовательной организации отсутствуют заключенные и планируемые к заключению договоры с иностранными и (или) международными организациями по вопросам образования и науки.'
      },
      {
        id: 2,
        name: 'О международной аккредитации образовательных программ (при наличии)',
        description: 'У образовательной организации отсутствуют образовательные программы, прошедшие международную аккредитацию.'
      }
    ])

    const test = () => {
      console.log(cooperationCategories)
    }

    return {
      cooperationCategories,
      test
    }
  }
}
</script>

<style lang="scss" scoped>
.cooperation {
  &__title {
    @include information-block-title;
    margin-bottom: 16px;
  }

  &__table {
    text-align: left;

    tr {
      vertical-align: top;
    }
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    width: 20%;
    padding-right: 20px;

    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    :deep(.p-inputtextarea) {
      margin-bottom: 10px;
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
